// @flow

import type { Action } from './store.type';

export const GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST =
  'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST';
type GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST_TYPE = 'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST';

export const GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS =
  'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS';
type GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS_TYPE = 'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS';

export const GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE =
  'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE';
type GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE_TYPE = 'GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE';

export const MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST';
type MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST_TYPE = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST';

export const MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS';
type MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS_TYPE = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS';

export const MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE';
type MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE_TYPE = 'MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE';

export const ENABLE_NEW_ONBOARDING_REQUEST = 'ENABLE_NEW_ONBOARDING_REQUEST';
type ENABLE_NEW_ONBOARDING_REQUEST_TYPE = 'ENABLE_NEW_ONBOARDING_REQUEST';

export const ENABLE_NEW_ONBOARDING_SUCCESS = 'ENABLE_NEW_ONBOARDING_SUCCESS';
type ENABLE_NEW_ONBOARDING_SUCCESS_TYPE = 'ENABLE_NEW_ONBOARDING_SUCCESS';

export const ENABLE_NEW_ONBOARDING_FAILURE = 'ENABLE_NEW_ONBOARDING_FAILURE';
type ENABLE_NEW_ONBOARDING_FAILURE_TYPE = 'ENABLE_NEW_ONBOARDING_FAILURE';

export const SEND_SURVEY_FEEDBACK_REQUEST = 'SEND_SURVEY_FEEDBACK_REQUEST';
type SEND_SURVEY_FEEDBACK_REQUEST_TYPE = 'SEND_SURVEY_FEEDBACK_REQUEST';

export const SEND_SURVEY_FEEDBACK_SUCCESS = 'SEND_SURVEY_FEEDBACK_SUCCESS';
type SEND_SURVEY_FEEDBACK_SUCCESS_TYPE = 'SEND_SURVEY_FEEDBACK_SUCCESS';

export const SEND_SURVEY_FEEDBACK_FAILURE = 'SEND_SURVEY_FEEDBACK_FAILURE';
type SEND_SURVEY_FEEDBACK_FAILURE_TYPE = 'SEND_SURVEY_FEEDBACK_FAILURE';

export const RESET_SURVEY_FEEDBACK = 'RESET_SURVEY_FEEDBACK';
type RESET_SURVEY_FEEDBACK_TYPE = 'RESET_SURVEY_FEEDBACK';

export const SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST =
  'SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST';
type SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST_TYPE = 'SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST';

export const SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS =
  'SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS';
type SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS_TYPE = 'SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS';

export const SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE =
  'SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE';
type SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE_TYPE = 'SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE';


export const MARK_DONE_TOUR_AB_TESTING_REQUEST = 'MARK_DONE_TOUR_AB_TESTING_REQUEST';

export const MARK_DONE_TOUR_AB_TESTING_SUCCESS = 'MARK_DONE_TOUR_AB_TESTING_SUCCESS';

export const MARK_DONE_TOUR_AB_TESTING_FAILURE = 'MARK_DONE_TOUR_AB_TESTING_FAILURE';

export const UPDATE_FIELD = `COMMON_UPDATE_FIELD`;
type UPDATE_FIELD_TYPE = 'COMMON_UPDATE_FIELD';
type UpdateFieldAction = Action<UPDATE_FIELD_TYPE, any>;

export const UPDATE_MULTI_FIELDS = 'COMMON_UPDATE_MULTI_FIELDS';
type UPDATE_MULTI_FIELDS_TYPE = 'COMMON_UPDATE_MULTI_FIELDS';
type UpdateMultiFieldsAction = Action<UPDATE_MULTI_FIELDS_TYPE, any>;

type CommonSuccess = {
  data: Object
};

type CommonFailure = {
  error: any
};
type GetMigrateNewFlowRequestAction = Action<GET_STATUS_MIGRATE_DATA_NEW_SEARCH_REQUEST_TYPE, null>;

type GetCommonSuccessAction = Action<
  GET_STATUS_MIGRATE_DATA_NEW_SEARCH_SUCCESS_TYPE,
  CommonSuccess
>;

type GetCommonFailureAction = Action<
  GET_STATUS_MIGRATE_DATA_NEW_SEARCH_FAILURE_TYPE,
  CommonFailure
>;

type MigrateNewSearchRequestAction = Action<MIGRATE_DATA_TO_NEW_SEARCH_V2_REQUEST_TYPE, null>;

type MigrateNewSearchSuccessAction = Action<
  MIGRATE_DATA_TO_NEW_SEARCH_V2_SUCCESS_TYPE,
  CommonSuccess
>;

type MigrateNewSearchFailureAction = Action<
  MIGRATE_DATA_TO_NEW_SEARCH_V2_FAILURE_TYPE,
  CommonFailure
>;
type EnableNewFeatureOnboardingRequestAction = Action<ENABLE_NEW_ONBOARDING_REQUEST_TYPE, null>;

type EnableNewFeatureOnboardingSuccessAction = Action<
  ENABLE_NEW_ONBOARDING_SUCCESS_TYPE,
  CommonSuccess
>;

type EnableNewFeatureOnboardingFailureAction = Action<
  ENABLE_NEW_ONBOARDING_FAILURE_TYPE,
  CommonFailure
>;

type SendSurveyFeedbackRequestAction = Action<SEND_SURVEY_FEEDBACK_REQUEST_TYPE, null>;

type SendSurveyFeedbackSuccessAction = Action<SEND_SURVEY_FEEDBACK_SUCCESS_TYPE, CommonSuccess>;

type SendSurveyFeedbackFailureAction = Action<SEND_SURVEY_FEEDBACK_FAILURE_TYPE, CommonFailure>;

type ResetSurveyFeedbackAction = Action<RESET_SURVEY_FEEDBACK_TYPE, CommonFailure>;

type SendFeedbackAfterRating5StarsRequestAction = Action<
  SEND_FEEDBACK_AFTER_RATING_5STARS_REQUEST_TYPE,
  null
>;

type SendFeedbackAfterRating5StarsSuccessAction = Action<
  SEND_FEEDBACK_AFTER_RATING_5STARS_SUCCESS_TYPE,
  CommonSuccess
>;

type SendFeedbackAfterRating5StarsFailureAction = Action<
  SEND_FEEDBACK_AFTER_RATING_5STARS_FAILURE_TYPE,
  CommonFailure
>;

export type MigrateNewFlowAction =
  | GetMigrateNewFlowRequestAction
  | GetCommonSuccessAction
  | GetCommonFailureAction
  | EnableNewFeatureOnboardingRequestAction
  | EnableNewFeatureOnboardingSuccessAction
  | EnableNewFeatureOnboardingFailureAction
  | MigrateNewSearchRequestAction
  | MigrateNewSearchSuccessAction
  | MigrateNewSearchFailureAction
  | SendSurveyFeedbackRequestAction
  | SendSurveyFeedbackSuccessAction
  | SendSurveyFeedbackFailureAction
  | ResetSurveyFeedbackAction
  | SendFeedbackAfterRating5StarsRequestAction
  | SendFeedbackAfterRating5StarsSuccessAction
  | SendFeedbackAfterRating5StarsFailureAction
  | UpdateFieldAction
  | UpdateMultiFieldsAction;

export type MigrateNewFlowState = {
  getLoading: boolean,
  updateLoading: boolean,
  success: boolean,
  error: any,
  migrateNewFlow: {}
};
